var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sm-text',{attrs:{"text":_vm.text,"color":"secondary","format":"sm-ow__caption"}}),_c('v-progress-linear',{staticClass:"mt-2 sm__progress-linear",attrs:{"value":_vm.progressRate,"color":"primary","height":"8","rounded":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }